import OrganizationCategoryPage from './OrganizationCategoryPage';

export default OrganizationCategoryPage;
